import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { Style } from "./Style";
import { CustomButton } from "..";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { selectUser } from "../../store/slice/user";
import { useSelector } from "react-redux";

const TicketStatusSub = ({ success }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { language } = useSelector(selectUser);
  const isArabic = language === "ar"
  return (
    <Box sx={Style.main}>
      <Box sx={success ? Style.badgeCircle : Style.badgeCircleFail}>
        {success ? <CheckIcon fontSize="inherit" /> : <CloseIcon fontSize="inherit" />}
      </Box>
      <Typography sx={Style.statusText(isArabic)}>
        {success ? t("ticket_status_page.thank_you") : t("ticket_status_page.failure")}
      </Typography>
      <Typography sx={Style.message(isArabic)}>
        {success
          ? t("ticket_status_page.payment_positive_status_sub")
          : t("ticket_status_page.payment_negative_status")}
      </Typography>
      
      <CustomButton
        onClick={() => navigate("/")}
        buttonText={t("ticket_status_page.home")}
        color="black"
        sx={Style.backButton(isArabic)}
      />
    </Box>
  );
};

export default TicketStatusSub;
